import React, { useState, useEffect, useCallback } from "react";
import { Link } from 'react-router-dom';
import authLayout from "../hoc/authLayout";
import logoimage from "../img/hero-slider/favicon.png";
import faviconimg from "../img/hero-slider/favicon.png";
import imgawards from "../img/an-awards-image-2.png";
import imgreview1 from "../img/review/1.jpg";
import imgreview2 from "../img/review/2.jpg";
import imgreview3 from "../img/review/3.jpg";
import imgreview4 from "../img/review/4.jpg";
import imgreview5 from "../img/review/5.jpg";
import imgreview6 from "../img/review/6.jpg";
import imgwhatsapp from "../img/hero-slider/whatsapp.png";
import imgback from "../img/hero-slider/1.jpg";
import imgbacksmall from "../img/homebanner.jpeg";
import axios from "axios";
import baseURL from "../common/base-urls.js";
import '../css/bootstrap.min.css';
import '../css/main.css';
import '../css/theme-dark.css';
import '../css/new.css';
// import '../js/jquery-3.5.1.min.js';
// import '../js/aos.js';
// import '../js/swiper-bundle.min.js';
// import '../js/main.js';
import debounce from "lodash/debounce";
import useSWR, { mutate } from "swr";
import { useNavigate, useLocation } from "react-router-dom";

const Index = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [apiUrl, setApiUrl] = useState('');
  const [apiUpcomingUrl, setUpcomingApiUrl] = useState('');
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
 const [backgroundImage, setBackgroundImage] = useState(imgback); // default to desktop

  useEffect(() => {
    const checkDevice = () => {
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      setBackgroundImage(isMobile ? imgbacksmall : imgback);
    };

    // Check on mount
    checkDevice();

    // Optional: Update on window resize
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);


  //#region ====================================================== Create State =====================================================
  const [state, setState] = useState({
    delete_id: "0",
    lblpagedisplay: 0,
    total_pages: 0,
    pagination: [],
    show_filter: false,
    filter_applied: false,
    show_toast: false,
    toast_msg: "No record found",
    show_modal: false,
    modal_title: "Confirmation",
    modal_msg:
      "Are you absolutely certain you want to delete this record? This action cannot be reversed.",
    modal_button: "Delete",
  });
  //#endregion
  //#region ====================================================== Update State ======================================================
  const updateState = (key, value) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };
  //#endregion 
  //#region ====================================================== Page Table Bind Data ======================================================
  let tbldata = {};
  let tblupcomingdata = {};
  let tblpagination = {};
  useEffect(() => {

    const queryParams = {
      page: page,
      limit: limit
    };
    const newApiUrl = `projects/`;
    setApiUrl(newApiUrl);
    const newupcomingApiUrl = `projecttype/`;
    setUpcomingApiUrl(newupcomingApiUrl);


  }, []);
  const { data, error, isValidating } = useSWR(
    apiUrl,
    () => getAPI(apiUrl, false),
    {
      revalidateOnReconnect: false,
      revalidateOnFocus: false,
    }
  );
  tbldata = data;

  const { data: newdata, error1, isValidating1 } = useSWR(
    apiUpcomingUrl,
    () => getAPI(apiUpcomingUrl, false),
    {
      revalidateOnReconnect: false,
      revalidateOnFocus: false,
    }
  );
  tblupcomingdata = newdata;


  //#endregion
  //#region ====================================================== Pagination & Page Changed ======================================================
  useEffect(() => {
    try {
      if (tbldata && tbldata.data && tbldata.data.hasOwnProperty("count") && tbldata.data.count > 0) {
        let dblPageCount = Math.ceil(parseInt(tbldata.data.count) / limit);
        let pageCount = Math.max(1, dblPageCount);
        updateState("total_pages", pageCount);
        let rows = [];
        if (pageCount > 0) {
          for (let i = 1; i <= pageCount; i++) {
            if (i == 1 || i == pageCount) {
              rows.push({ text: i.toString(), value: i.toString(), enabled: i != parseInt(page) });
            }
            else if ((i >= parseInt(page) - 2) && (i <= parseInt(page) + 3)) {
              rows.push({ text: i.toString(), value: i.toString(), enabled: i != parseInt(page) });
            }
            else if (((i > parseInt(page) + 3) && (i >= pageCount - 2))) {
              rows.push({ text: i.toString(), value: i.toString(), enabled: i != parseInt(page) });
            }
          }
        } else {
          pageCount = '0';
        }
        setState((prevState) => ({
          ...prevState,
          pagination: rows
        }));
        tblpagination = rows;
        let firstpage = 1;
        let lastpage = 1;
        if (parseInt(page) === 1) {
          if (limit * parseInt(page) <= parseInt(tbldata.data.count)) {
            firstpage = 1;
            lastpage = limit;
          } else {
            firstpage = 1;
            lastpage = parseInt(tbldata.data.count);
          }
        } else {
          if (limit * parseInt(page) <= parseInt(tbldata.data.count)) {
            firstpage = limit * (parseInt(page) - 1) + 1;
            lastpage = limit * parseInt(page);
          } else {
            lastpage = parseInt(tbldata.data.count);
            firstpage = limit * (parseInt(page) - 1) + 1;
          }
        }
        updateState("lblpagedisplay", tbldata.data.count !== '0' ? `${firstpage} - ${lastpage}` : '0 - 0');
        if (lastpage === 0) {
          firstpage = 0;
          updateState("lblpagedisplay", tbldata.data.count !== '0' ? `${firstpage} - ${lastpage}` : '0 - 0');
        }
      }
    } catch (ex) {
    }
  }, [data]);
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  //#endregion  
  const editRecord = (projectId) => {
    try {
      navigate("/project", { state: { editid: projectId } });
    } catch (err) { }
  };
  const debouncedEditRecord = debounce((projectId) => {
    editRecord(projectId);
  }, 500);

  const addRecord = () => {
    try {
      navigate("admin.vasutsdc.in");
    } catch (err) { }
  };
  const debouncedAddRecord = debounce(addRecord, 500);
  //#endregion 
  //#region ====================================================== Get API ======================================================
  const getAPI = async (url, Auth) => {
    try {

      const response = await axios.get(`${baseURL.serverUrl}${url}`, {
        headers: {
        },
      });
      return response.data;

    } catch (err) {
      return {};
    }
  };
  //#endregion 
  useEffect(() => {
    document.querySelectorAll('a[href^="/"], a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const href = this.getAttribute('href');
        const id = href.startsWith('#') ? href.substring(1) : href; // Remove the leading slash or hash

        if (id === '/privacy' || id === '/terms') {
          // Navigate to privacy or terms page
          window.location.href = window.location.origin + '#/' + id.substring(1);
          // Scroll to the top of the page
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
        else if (id === '/') {
          // Navigate to privacy or terms page
          window.location.href = window.location.origin;
          // Scroll to the top of the page
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
        else if (id !== '') {
          // Scroll to the element with the corresponding ID
          const element = document.getElementById(id);
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth'
            });
          }
        } else {
          // Handle routing for React Router links
          window.location.href = href;
        }
      });
    });
  }, []);
  useEffect(() => {
    const filterButtons = document.querySelectorAll(".filter__item");
    const items = document.querySelectorAll(".works__item");

    filterButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        // Remove active state from all buttons
        filterButtons.forEach((b) => b.classList.remove("filter__item--active"));
        btn.classList.add("filter__item--active");

        const filterValue = btn.getAttribute("data-filter");

        items.forEach((item) => {
          if (filterValue === "*") {
            item.style.display = "block";
          } else {
            if (item.classList.contains(filterValue.replace(".", ""))) {
              item.style.display = "block";
            } else {
              item.style.display = "none";
            }
          }
        });
      });
    });

    // Cleanup event listeners
    return () => {
      filterButtons.forEach((btn) => {
        btn.replaceWith(btn.cloneNode(true));
      });
    };
  }, [tbldata]);
useEffect(() => {
        const handleContextMenu = (e) => {
            e.preventDefault();
        };
        document.addEventListener('contextmenu', handleContextMenu);

        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
        };
    }, []);


  return (
    <>
      <style>{`
        
.work-card__image::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 70%);
  pointer-events: none; /* so it doesn't block clicks */
}
  .work-card--compact .work-card__image, .work-card--masonry .work-card__image
  { cursor:pointer;
  }
      `}</style>

      <div className="animsition animationcss">
        <header className="header header-3">
          <div className="header__inner">
            <a href="/" className="header__logo logo">
              <span className="logo__image">
                <img alt="Architect,Urban Designer,Interior designer" loading="lazy" src={logoimage} className="width60" />
              </span>
              <span className="logo__text logocolor">Architect's Design Studio</span>
            </a>
          </div>
        </header>
        <main>
          <div className="homepage-different">
            <section id="home"  style={{
        backgroundImage: `url(${backgroundImage})`, 
      }} className="section pp-scrollable an-awards an-awards--different an-awards--parallax homeback">
              <div className="layer homelayer">
              </div>
              <div className="scroll-wrap">
                <div className="container an-awards__container">
                  <div className="row align-items-center">
                    <div className="an-awards__content col-12 col-md col-lg-6">
                      <div className="an-awards__welcome">
                        welcome to

                        <br />
                        Architect's Design Studio

                      </div>
                      <h1 className="an-awards__heading heading heading--h1 logocolor">
                        Innovating Spaces, Inspiring Lives

                        {/* <br />
                        Best Architects Studio */}
                      </h1>
                      <div className="an-awards__text fontsize18">
                        Each design is a story—crafted with creativity, lived with joy, remembered in time. Our spaces aren’t just built, they’re experienced.

                      </div>
                      <div className="an-awards__buttons">
                        <a className="btn" href="#projects">our projects</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section id="process" className="section pp-scrollable type-service type-service--different dark lightback">
              <div className="scroll-wrap">
                <div className="container">
                  <h2 className="type-service__heading heading">Our process to build your dream project</h2>
                  <ul className="type-service__list row">
                    <li className="type-service__item col-12 col-md">
                      <a href="#">
                        <div className="type-service__item-icon type-service__item-icon--interior">

                          <svg width="49" height="49" viewBox="0 -64 640 640">
                            <path d="M519.2 127.9l-47.6-47.6A56.252 56.252 0 0 0 432 64H205.2c-14.8 0-29.1 5.9-39.6 16.3L118 127.9H0v255.7h64c17.6 0 31.8-14.2 31.9-31.7h9.1l84.6 76.4c30.9 25.1 73.8 25.7 105.6 3.8 12.5 10.8 26 15.9 41.1 15.9 18.2 0 35.3-7.4 48.8-24 22.1 8.7 48.2 2.6 64-16.8l26.2-32.3c5.6-6.9 9.1-14.8 10.9-23h57.9c.1 17.5 14.4 31.7 31.9 31.7h64V127.9H519.2zM48 351.6c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16zm390-6.9l-26.1 32.2c-2.8 3.4-7.8 4-11.3 1.2l-23.9-19.4-30 36.5c-6 7.3-15 4.8-18 2.4l-36.8-31.5-15.6 19.2c-13.9 17.1-39.2 19.7-55.3 6.6l-97.3-88H96V175.8h41.9l61.7-61.6c2-.8 3.7-1.5 5.7-2.3H262l-38.7 35.5c-29.4 26.9-31.1 72.3-4.4 101.3 14.8 16.2 61.2 41.2 101.5 4.4l8.2-7.5 108.2 87.8c3.4 2.8 3.9 7.9 1.2 11.3zm106-40.8h-69.2c-2.3-2.8-4.9-5.4-7.7-7.7l-102.7-83.4 12.5-11.4c6.5-6 7-16.1 1-22.6L367 167.1c-6-6.5-16.1-6.9-22.6-1l-55.2 50.6c-9.5 8.7-25.7 9.4-34.6 0-9.3-9.9-8.5-25.1 1.2-33.9l65.6-60.1c7.4-6.8 17-10.5 27-10.5l83.7-.2c2.1 0 4.1.8 5.5 2.3l61.7 61.6H544v128zm48 47.7c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16z" />
                          </svg>

                        </div>
                        <h3 className="type-service__item-heading">Meet & agree</h3>
                        <div className="type-service__item-text">Our first meeting at a site where a discussion of your priorities and design needs can take place where we ll sign an agreement.</div>
                        <div className="type-service__item-link">Step 1</div>
                      </a>
                    </li>
                    <li className="type-service__item col-12 col-md">
                      <a href="#">
                        <div className="type-service__item-icon type-service__item-icon--design">
                          <svg width="49" height="49" viewBox="0 0 24 24">
                            <path d="M5.57489 2.07403C5.83474 2.19892 6 2.4617 6 2.75001C6 3.57985 6.31211 4.05763 6.70313 4.63948L6.73156 4.68175C7.0641 5.17579 7.5 5.8234 7.5 6.75001C7.5 7.69552 7.02282 8.52959 6.29615 9.02452C6.48733 9.1848 6.65672 9.38248 6.80225 9.61803C7.27801 10.388 7.5 11.5645 7.5 13.2549C7.5 14.967 7.27003 17.023 6.89541 18.6644C6.70914 19.4806 6.47843 20.2335 6.20272 20.7994C6.06598 21.08 5.89948 21.3541 5.69217 21.5685C5.48714 21.7804 5.17035 22.0049 4.75 22.0049C4.32965 22.0049 4.01286 21.7804 3.80783 21.5685C3.60052 21.3541 3.43402 21.08 3.29728 20.7994C3.02157 20.2335 2.79086 19.4806 2.60459 18.6644C2.22997 17.023 2 14.967 2 13.2549C2 11.5645 2.22199 10.388 2.69775 9.61803C2.84328 9.38248 3.01267 9.1848 3.20385 9.02452C2.47718 8.52959 2 7.69552 2 6.75001C2 6.38181 2.00034 5.74889 2.38341 4.93168C2.75829 4.13192 3.47066 3.21301 4.78148 2.16436C5.00661 1.98425 5.31504 1.94914 5.57489 2.07403ZM3.5 6.74875V6.75001C3.5 7.44036 4.05964 8.00001 4.75 8.00001C5.44036 8.00001 6 7.44036 6 6.75001C6 6.31097 5.81518 6.00743 5.45814 5.47615L5.44592 5.45796C5.21705 5.11747 4.94673 4.71532 4.75381 4.19756C4.21053 4.74999 3.9105 5.208 3.74159 5.56833C3.5 6.08374 3.5 6.4505 3.5 6.74875ZM3.97383 10.4065C3.72572 10.808 3.5 11.6315 3.5 13.2549C3.5 14.8565 3.71774 16.8005 4.06698 18.3306C4.24264 19.1003 4.44289 19.726 4.64574 20.1424C4.68308 20.219 4.71806 20.2834 4.75 20.3369C4.78194 20.2834 4.81692 20.219 4.85426 20.1424C5.05711 19.726 5.25736 19.1003 5.43302 18.3306C5.78226 16.8005 6 14.8565 6 13.2549C6 11.6315 5.77428 10.808 5.52617 10.4065C5.41327 10.2237 5.30119 10.1372 5.20105 10.0886C5.09322 10.0363 4.95068 10.0049 4.75 10.0049C4.54932 10.0049 4.40678 10.0363 4.29895 10.0886C4.19881 10.1372 4.08673 10.2237 3.97383 10.4065Z" />
                            <path d="M9.99994 14.917C9.46162 14.8267 8.94761 14.6647 8.46806 14.4412C8.48904 14.0349 8.49994 13.637 8.49994 13.2549C8.49994 13.0791 8.49768 12.9066 8.49298 12.7376C8.94409 13.0407 9.4531 13.2644 9.99994 13.3885V10.5C9.99994 9.67157 10.6715 9 11.4999 9H15.4999C15.4999 6.51472 13.4852 4.5 10.9999 4.5C9.97153 4.5 9.0237 4.84498 8.26586 5.42552C8.06633 4.8731 7.78116 4.44995 7.58275 4.15554L7.54248 4.09572C8.51976 3.40549 9.7125 3 10.9999 3C14.3136 3 16.9999 5.68629 16.9999 9H20.4999C21.3284 9 21.9999 9.67157 21.9999 10.5V19.5C21.9999 20.3284 21.3284 21 20.4999 21H11.4999C10.6715 21 9.99994 20.3284 9.99994 19.5V14.917ZM11.4999 14.9795V19.5H20.4999V10.5H16.8109C16.185 12.932 14.0726 14.7672 11.4999 14.9795ZM15.2439 10.5H11.4999V13.4725C13.239 13.2803 14.6794 12.097 15.2439 10.5Z" />
                          </svg>

                        </div>
                        <h3 className="type-service__item-heading">Design & create</h3>
                        <div className="type-service__item-text">From initial concepts and planning through to detailing and completion, we work collaboratively with the whole design team, clients, consultants.</div>
                        <div className="type-service__item-link">Step 2</div>
                      </a>
                    </li>
                    <li className="type-service__item col-12 col-md">
                      <a href="#">
                        <div className="type-service__item-icon type-service__item-icon--furniture">
                          <svg version="1.1" id="Layer_1" x="0px" y="0px"
                            viewBox="0 0 512 512" className="svgback2" width="49" height="49" >
                            <g>
                              <g>
                                <path d="M436.494,282.174l-20.377-15.098c2.325-15.684,2.343-31.45,0.051-46.996l20.326-15.061
			c2.956-2.19,4.042-6.111,2.634-9.509l-19.635-47.401c-1.408-3.399-4.952-5.405-8.586-4.861l-25.022,3.723
			c-9.373-12.613-20.532-23.748-33.269-33.196l3.734-25.086c0.541-3.639-1.463-7.179-4.861-8.586l-47.401-19.633
			c-3.398-1.408-7.32-0.322-9.509,2.634l-4.908,6.623V25.119C289.67,11.268,278.402,0,264.551,0h-17.102
			c-13.851,0-25.119,11.268-25.119,25.119v44.607l-4.908-6.624c-2.189-2.956-6.11-4.041-9.509-2.634l-47.401,19.633
			c-3.399,1.408-5.403,4.948-4.861,8.586l3.723,25.023c-12.612,9.373-23.747,20.531-33.194,33.268l-25.086-3.733
			c-3.64-0.543-7.179,1.463-8.586,4.861l-19.635,47.401c-1.408,3.399-0.322,7.32,2.634,9.509l20.377,15.098
			c-2.325,15.684-2.342,31.45-0.051,46.996l-20.326,15.061c-2.956,2.19-4.042,6.111-2.634,9.509l19.635,47.402
			c1.408,3.399,4.952,5.404,8.586,4.861l25.023-3.723c9.373,12.613,20.531,23.748,33.268,33.196l-3.734,25.086
			c-0.541,3.638,1.463,7.179,4.861,8.586l47.401,19.635c3.399,1.408,7.32,0.322,9.509-2.634l4.908-6.624v1.005
			c0,0.78,0.113,1.556,0.338,2.303l25.653,85.512C249.339,509.677,252.46,512,256,512c3.54,0,6.661-2.323,7.679-5.713l25.653-85.512
			c0.224-0.747,0.338-1.523,0.338-2.303v-1.005l4.908,6.624c1.548,2.09,3.961,3.245,6.443,3.245c1.028,0,2.069-0.199,3.066-0.61
			l47.401-19.635c3.399-1.408,5.403-4.948,4.861-8.586l-3.723-25.023c12.613-9.373,23.749-20.533,33.196-33.268l25.085,3.733
			c3.64,0.543,7.179-1.463,8.586-4.861l19.634-47.401C440.536,288.285,439.45,284.364,436.494,282.174z M238.363,25.119
			c0-5.01,4.076-9.086,9.086-9.086h17.102c5.01,0,9.086,4.076,9.086,9.086v17.637h-35.273V25.119z M238.363,58.789h35.273v23.934
			c-11.777-1.315-23.577-1.331-35.273-0.049V58.789z M222.33,303.75c-13.41-7.526-24.082-19.421-30.025-33.77
			c-13.5-32.592-0.047-69.723,30.025-86.53V303.75z M256,476.084l-14.879-49.596h29.757L256,476.084z M273.637,410.455h-35.273
			V176.963c11.837-3.14,23.967-2.982,35.273,0.026V410.455z M223.481,165.088c-43.29,17.932-63.92,67.739-45.989,111.028
			c8.448,20.398,24.65,36.771,44.838,45.5v19.482c-27.974-9.609-50.177-30.385-61.626-58.028
			c-21.765-52.547,3.277-113.005,55.824-134.769c52.547-21.765,113.003,3.276,134.769,55.823c10.544,25.455,10.544,53.492,0,78.946
			c-10.544,25.455-30.368,45.279-55.823,55.824c-1.909,0.79-3.849,1.513-5.803,2.189v-19.487h-0.001
			c20.412-8.802,36.313-24.898,44.839-45.479c8.686-20.971,8.686-44.068,0-65.039C316.577,167.789,266.771,147.159,223.481,165.088z
			 M289.67,303.749v-120.26c13.065,7.301,23.867,18.856,30.025,33.725c7.047,17.014,7.047,35.753,0,52.767
			C313.691,284.476,303.171,296.225,289.67,303.749z M407.076,327.167l-23.731-3.531c-3.015-0.449-6.021,0.85-7.761,3.351
			c-9.92,14.259-22.095,26.459-36.185,36.261c-2.501,1.74-3.8,4.747-3.351,7.761l3.521,23.665l-35.836,14.844l-14.063-18.982V357.93
			c4.039-1.196,8.039-2.608,11.938-4.223c29.412-12.182,52.318-35.09,64.5-64.5c12.182-29.411,12.182-61.807,0-91.217
			c-25.149-60.714-95.005-89.648-155.719-64.5c-60.714,25.148-89.649,95.003-64.501,155.719
			c13.937,33.648,41.659,58.492,76.44,68.717v32.613l-14.065,18.981l-35.836-14.844l3.532-23.73c0.448-3.013-0.85-6.021-3.351-7.761
			c-14.259-9.922-26.459-22.096-36.261-36.185c-1.74-2.501-4.747-3.801-7.761-3.351l-23.665,3.521l-14.844-35.836l19.223-14.243
			c2.449-1.814,3.657-4.859,3.118-7.859c-3.031-16.894-3.014-34.13,0.053-51.227c0.538-2.999-0.669-6.044-3.118-7.857
			l-19.278-14.284l14.844-35.836l23.73,3.531c3.013,0.448,6.02-0.85,7.76-3.35c9.923-14.26,22.097-26.46,36.185-36.261
			c2.501-1.739,3.8-4.747,3.351-7.76l-3.521-23.665l35.836-14.844l14.244,19.224c1.814,2.449,4.857,3.656,7.857,3.118
			c16.892-3.031,34.127-3.014,51.227,0.053c2.997,0.538,6.042-0.67,7.856-3.118l14.284-19.278l35.836,14.844l-3.532,23.732
			c-0.448,3.013,0.85,6.02,3.351,7.76c14.26,9.922,26.459,22.096,36.261,36.185c1.74,2.501,4.749,3.802,7.761,3.351l23.665-3.521
			l14.844,35.835l-19.223,14.244c-2.449,1.814-3.657,4.858-3.118,7.857c3.031,16.895,3.014,34.13-0.053,51.227
			c-0.538,2.999,0.669,6.044,3.118,7.857l19.277,14.284L407.076,327.167z" />
                              </g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                          </svg>

                        </div>
                        <h3 className="type-service__item-heading">Build & install</h3>
                        <div className="type-service__item-text">The terminology build has a higher level than compile. Install means putting the executable file to the suitable location and setting file permission stuff, that’s all.</div>
                        <div className="type-service__item-link">Step 3</div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </section>

            <section id="expertise" className="section pp-scrollable  our-story our-story--different dark about__simplicity backmargin">
              <div className="scroll-wrap">
                <div className="our-story__inner  container bcontainer">
                  <div className="row">
                    <div className="simplicity__content col-12 col-md-6">
                      <h2 className="simplicity__heading heading" data-aos="fade">Simplicity Is The Ultimate Sophistictation</h2>
                      <div className="simplicity__subheading" data-aos="fade">We know that good design mean that good business.</div>
                      <div className="simplicity__text" data-aos="fade">The firm has evolved with changing times and has a young work force, guided by experienced professionals in the core team. The skilled and collaborative workforce including in-house architects, designers, 3D visualizers and engineers, is well-supported by competent structural and service consultants.</div>
                      <div className="simplicity__notice" data-aos="fade">If you're hurry, quick call for us.</div>
                      <div className="simplicity__phone phone-block phone-block--theme-orange" data-aos="fade">
                        <div className="phone-block__icon">
                          <svg width="18" height="18" viewBox="0 0 64 64">
                            <path d="M61.6 44.1l-9.3-5.9c-2.4-1.3-5.3-.8-6.9 1.3l-2.1 3.2c-12-7.2-19.5-16.8-22.4-21.1l3.5-2.1c1.1-.8 1.9-1.9 2.1-3.2.3-1.3 0-2.7-.8-3.7l-6.1-8.8C18 1.7 15.1.9 12.9 2.2L4 7c-.5.3-.8.5-1.3.8C-4 15 2.1 31.3 17.6 45.9c11.2 10.7 23.2 16.5 31.7 16.5 3.2 0 5.9-.8 7.7-2.4l1.1-1.1 5.1-8c1.6-2.3.8-5.5-1.6-6.8zm-8 11.9c-4.6 3.8-18.9-1-32.5-13.8C7.7 29.4 2.7 15.8 6.7 11.5L15 6.7l5.9 8.5-3.5 2.1c-1.1.8-1.9 1.9-2.1 3.2-.3 1.3 0 2.7.8 3.7 2.9 4.3 11.2 15.2 24.3 23.2 2.4 1.3 5.3.8 6.9-1.3l2.4-3.5 9.1 5.6-5.2 7.8z" />

                          </svg>
                        </div>
                        <div className="phone-block__content">
                          <div className="phone-block__hint">hotline 24/7</div>
                          <a href="tel:+919033718216" className="phone-block__number fontsize18">+91 90337 18216</a>
                          <br />
                          <span className="phone-block__number phonenumber">OR</span> <a href="tel:02613696240" className="phone-block__number displayinline18">0261 3696240</a>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 type-service type-service--lite">
                      <ul className="type-service__list">
                        <li className="type-service__item transcss" data-aos="fade">
                          <a href="#">
                            <div className="type-service__item-icon type-service__item-icon--interior">
                              <svg width="49" height="49" viewBox="0 0 17 17">
                                <path d="M4.492 0H2.508c-.827 0-1.5.673-1.5 1.5v10.657l2.521 4.956 2.464-4.959V1.5A1.503 1.503 0 004.492 0zM2.508 1h1.984c.275 0 .5.225.5.5v1.019H2.008V1.5a.5.5 0 01.5-.5zm-.5 3.55V3.519h2.984V4.55H2.008zm1.94 9.471h-.87l-1.07-2.104V5.55h1v6.481h1V5.55h.984v6.37l-1.044 2.101zM8 0v17h7V0H8zm6 16H9v-.984h2v-1H9V13h1v-1H9v-1h2v-1H9v-.984h1v-1H9v-1h2v-1H9V5h1V4H9V3h2V2H9V1h5v15z" />
                              </svg>
                            </div>
                            <h3 className="type-service__item-heading">Building design</h3>
                            <div className="type-service__item-text">Architectural, engineering and technical applications to the design of buildings.</div>
                          </a>
                        </li>
                        <li className="type-service__item transcss" data-aos="fade" data-aos-delay="300">
                          <a href="#">
                            <div className="type-service__item-icon type-service__item-icon--design">
                              <svg width="49" height="49" viewBox="0 0 17 17">
                                <path d="M14.94 6a6.46 6.46 0 00-3.44-1 6.49 6.49 0 00-2.239.404l2.569-2.569c.203.102.428.165.67.165.827 0 1.5-.673 1.5-1.5S13.327 0 12.5 0 11 .673 11 1.5c0 .22.05.428.136.616l-3.91 3.909A1.46 1.46 0 006.976 6c-.827 0-1.5.673-1.5 1.5 0 .085.011.168.025.25l-3.386 3.386A1.472 1.472 0 001.5 11c-.827 0-1.5.673-1.5 1.5S.673 14 1.5 14 3 13.327 3 12.5c0-.242-.063-.467-.165-.669l2.57-2.57A6.516 6.516 0 005 11.5c0 1.469.612 2.735 1 3.391V17h3v-3H6.664C6.246 13.174 6 12.287 6 11.5c0-.887.22-1.764.628-2.545.113.027.228.045.348.045.827 0 1.5-.673 1.5-1.5 0-.18-.037-.35-.095-.51 1.644-1.131 3.847-1.268 5.619-.373V9h3V6h-2.06zM12.5 1a.5.5 0 110 1 .5.5 0 010-1zm-11 12a.5.5 0 110-1 .5.5 0 010 1zM7 15h1v1H7v-1zm-.024-7a.5.5 0 110-1 .5.5 0 010 1zM16 8h-1V7h1v1z" />

                              </svg>
                            </div>
                            <h3 className="type-service__item-heading">Site & master planning</h3>
                            <div className="type-service__item-text">The design and process of planning & making the connection between buildings and their surrounding environments.</div>
                          </a>
                        </li>
                        <li className="type-service__item transcss" data-aos="fade" data-aos-delay="600">
                          <a href="#">
                            <div className="type-service__item-icon type-service__item-icon--furniture">
                              <svg width="49" height="49" viewBox="0 0 17 17">
                                <path d="M8.517-.035L0 3.186v10.693l8.5 3.188 8.5-3.188V3.187L8.517-.035zm6.567 3.563l-2.586.97-6.557-2.489 2.575-.974 6.568 2.493zM8.5 5.997L1.919 3.529l2.609-.986 6.551 2.487-2.579.967zM1 4.253l7 2.625v8.932l-7-2.625V4.253zM9 15.81V6.878l7-2.625v8.932L9 15.81z" />

                              </svg>
                            </div>
                            <h3 className="type-service__item-heading">Interior design</h3>
                            <div className="type-service__item-text">The art and science of enhancing the interior of a building to achieve a healthier & pleasing environment for the people using the space.</div>

                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <article id="projects" className="works-page">
              <header className="works-page__header">
                <div className="works-page__inner container">
                  <h1 className="works-page__heading heading">
                    Architecture is a visual art, and our projects speak through timeless design
                  </h1>
                  <div className="works-page__text">
                    From contemporary residences to cultural landmarks, every project reflects a balance of creativity and functionality.
                    We craft spaces that harmonize with their surroundings, blending modern aesthetics with thoughtful detailing.
                    Each design tells a story—where innovation meets tradition, and architecture becomes an experience.
                  </div>
                </div>
              </header>
              <div className="works-page__content">

                <section className="works">
                  {/* <div className="works__inner container">
                    <header className="works__header">

                      <div className="works__filter filter">
                        <button className="filter__item filter__item--active" type="button" data-filter="*">all</button>
                        <button className="filter__item" type="button" data-filter=".__js_residential">residential</button>
                        <button className="filter__item" type="button" data-filter=".__js_commercial">commercial</button>
                        <button className="filter__item" type="button" data-filter=".__js_architecture">architecture</button>
                        <button className="filter__item" type="button" data-filter=".__js_interior">interior</button>
                      </div>
                    </header>
                  </div> */}


                  <div className="works__inner container">
                    <header className="works__header">
                      <div className="works__filter filter">
                        {/* Always keep "all" */}
                        <button
                          className="filter__item filter__item--active"
                          type="button"
                          data-filter="*"
                        >
                          all
                        </button>

                        {/* Dynamically render unique service filters */}
                        {tbldata?.data?.projects &&
                          Array.from(
                            new Set(
                              tbldata.data.projects
                                .flatMap((p) =>
                                  p.services
                                    .split(",")
                                    .map((s) => s.trim())
                                    .filter(Boolean)
                                )
                            )
                          ).map((service) => {
                            const filterClass = `__js_${service.toLowerCase().replace(/\s+/g, "")}`;
                            return (
                              <button
                                key={service}
                                className="filter__item"
                                type="button"
                                data-filter={`.${filterClass}`}
                              >
                                {service}
                              </button>
                            );
                          })}
                      </div>
                    </header>
                  </div>




                  <div className="container-fluid">
                    <ul className="works__list row __js_works-filter">

                      {tbldata &&
                        (!tbldata.data || !tbldata.data.projects?.length) ? (
                        <>

                        </>
                      ) : (
                        <>
                          {tbldata &&
                            tbldata.data.projects.map((x) => {
                              // const year = new Date(x.projectdate).getFullYear();
                              const safeDate = x.projectdate?.replace(/-/g, "/"); // e.g. "2025-08-01" -> "2025/08/01"
                              const year = new Date(safeDate).getFullYear();
                              const servicesList = x.services
                                .split(",")
                                .map((s) => s.trim())
                                .filter(Boolean);

                              const typeClasses = servicesList.map((service) =>
                                `__js_${service.toLowerCase().replace(/\s+/g, "")}`
                              );

                              const allClasses = [
                                "works__item",
                                "work-card",
                                "work-card--compact",
                                "col-12",
                                "col-md-6",
                                "col-lg-4",
                                ...typeClasses,
                                `__js_${year}`,
                              ].join(" ");

                              return (
                                <li key={x.projectid} className={allClasses}>

                                  <a onClick={() => debouncedEditRecord(x?.projectid)} className="work-card__image"  >
                                    <img
                                      src={`/img/small/${x.projectid}/${x.bannerurl}`}
                                      width="640"
                                      height="582"
                                      alt={x.shorttitle || "ADS Architect"}
                                    />
                                  </a>
                                  <div className="work-card__content">
                                    <div className="work-card__year">{year}</div>
                                    <div className="work-card__tags">{x.subtitle}</div>
                                    <h2 className="work-card__heading">
                                      <a>{x.title}</a>
                                    </h2>
                                  </div>
                                </li>
                              );
                            })}

                        </>
                      )}

                    </ul>


                  </div>
                </section>
              </div>
            </article>




            <section id="aboutus" className="section pp-scrollable approach approach--different dark webpage__an-awards an-awards an-awards--about  about__simplicity backmargin">
              <div className="scroll-wrap padding7020">
                <div className="review__inner  container">
                  <div className="row align-items-center">
                    <div className="an-awards__intro col-12 col-md col-lg-7 order-md-1">
                      <div className="an-awards__image">
                        <img alt="Architect,Urban Designer,Interior designer" loading="lazy" src={imgawards} width="549" height="833" />
                      </div>
                    </div>
                    <div className="an-awards__content col-12 col-md col-lg-5">
                      <h1 className="an-awards__heading heading heading--h1">

                        <br />
                        Architect's
                        <br />
                        Design
                        <br />
                        Studio
                      </h1>
                      <div className="an-awards__text textjustify">ADS founder and CEO Ar. Vikrant Timbadiya’s focus is turning your dream projects into reality. He strongly believes in serving your needs by creating sustainable, functional and appealing designs.ADS strive to create a culture of design INNOVATION, encouraging experimentation and risk-taking to promote diverse thinking that can inoculate new ideas into our design process. Our vision to incorporate the elements of SPACE, AIR, SUN, WATER, and EARTH for long- term functionality and sustainability. Our mission is to provide our clients with the best practical design solutions for residential,commercial and institutional project.</div>

                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section id="testimony" className="section pp-scrollable review review--different dark">
              <div className="scroll-wrap">
                <div className="review__inner container">
                  <div className="row">
                    <div className="review__image col-12 col-md-7">
                      <span className="review__image-author review__image-author--one">
                        <img alt="Architect,Urban Designer,Interior designer" loading="lazy" src={imgreview1} width="165" height="165" />
                      </span>
                      <span className="review__image-author review__image-author--two">
                        <img alt="Architect,Urban Designer,Interior designer" loading="lazy" src={imgreview2} width="102" height="102" />
                      </span>
                      <span className="review__image-author review__image-author--three">
                        <img alt="Architect,Urban Designer,Interior designer" loading="lazy" src={imgreview3} width="125" height="125" />
                      </span>
                      <span className="review__image-author review__image-author--four">
                        <img alt="Architect,Urban Designer,Interior designer" loading="lazy" src={imgreview4} width="84" height="84" />
                      </span>
                      <span className="review__image-author review__image-author--five">
                        <img alt="Architect,Urban Designer,Interior designer" loading="lazy" src={imgreview5} width="75" height="75" />
                      </span>
                      <span className="review__image-author review__image-author--six">
                        <img alt="Architect,Urban Designer,Interior designer" loading="lazy" src={imgreview6} width="60" height="60" />
                      </span>
                    </div>
                    <div className="review__content col-12 col-md-5 align-self-center">
                      <div className="review__text">
                        Vikrant Timbadiya director of ADS is a combination of creativity, dedication, smart, hard work and affordable .
                        I can say is we have take right decision to assign ADS for our project. Unique design, impressive, and outstanding support. Vikrantbhai thanks for saving our money and time!

                      </div>
                      <div className="review__author">
                        <div className="review__author-name">Fenil Donda</div>
                        <div className="review__author-detail">
                          Director at <span>Galaxy Developer, India</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>






            <section id="contactus" className="section pp-scrollable  our-story our-story--different dark backmargin">
              <div className="scroll-wrap">
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-lg-6">
                      <div className="feedback-form__title colorwhite">
                        Contact us
                      </div>
                      <div className="contact-block">
                        <h2 className="contact-block__title">
                          Surat, <span className="colorwhite">Gujarat</span>
                        </h2>
                        <address className="contact-block__address">414-Oberon, opp. Mercedes benz showroom, New City Light, Surat, Gujarat 395007 </address>
                        <div className="contact-block__email">
                          <span className="contact-block__hint">Email:</span>
                          <a href="mailto:vk.adsarchitects@gmail.com"><span className="__cf_email__ fontsize16">vk.adsarchitects@gmail.com</span></a>
                        </div>
                        <div className="contact-block__phone">
                          <span className="contact-block__hint colorwhite">Call directly:</span>
                          <a href="tel:+919033718216" className="fontsize18">+91 90337 18216</a>
                          <br />
                          <span className="colorback">OR</span> <a href="tel:02613696240" className="displayinline18">0261 3696240</a>

                        </div>
                        <div className="contact-block__offices">
                          <span className="contact-block__hint">Brand Offices:</span>
                          <div className="contact-block__offices-list">
                            <a className="contact-block__offices-item" href="#">Surat Gujarat</a>
                            <a className="contact-block__offices-item" href="#">Ahmedabad, Gujarat</a>

                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-lg-6">


                      <div className="contacts-different__feedback feedback-form js-form-validate paddingtop45">


                        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14884.409828114432!2d72.7985076!3d21.1483205!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x22145bfcf6ace00c!2sADS%20Architects%20%26%20Interior%20designer!5e0!3m2!1sen!2sin!4v1660302625977!5m2!1sen!2sin" className="iframecss" allowfullscreen="" referrerpolicy="no-referrer-when-downgrade"></iframe>


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>

        <footer className="footer-3">

          <ul className="footer-3__socials">
            <li>
              <a href="https://www.facebook.com/ADSArchitectsDesignStudio" target="_blank">
                <svg width="14" height="14" viewBox="0 0 64 64">
                  <path d="M47.9 25.6H40V15h6.5c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2h-7.6C30.7 0 25 5.9 25 14.4v11.2h-9c-1.5 0-2.7 1.2-2.7 2.8v7.4c0 1.5 1.2 2.7 2.7 2.7h9v22.9c0 1.5 1.2 2.7 2.7 2.7h9.8c.6 0 1.2-.3 1.6-.7.5-.5.7-1.2.7-1.8V38.4h6.8c1.3 0 2.4-.9 2.6-2.1v-.2l1.4-7.1c.2-.8 0-1.6-.6-2.4-.4-.5-1.2-.9-2.1-1z" />
                </svg>
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/in/architect-s-design-studio-ads/" target="_blank">

                <svg width="14" height="14" version="1.1" id="Layer_1" x="0px" y="0px"
                  viewBox="0 0 310 310" className="svgback" >
                  <g id="XMLID_801_">
                    <path id="XMLID_802_" d="M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73
		C77.16,101.969,74.922,99.73,72.16,99.73z" />
                    <path id="XMLID_803_" d="M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4
		c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z" />
                    <path id="XMLID_804_" d="M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599
		c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319
		c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995
		C310,145.43,300.549,94.761,230.454,94.761z" />
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                </svg>

              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/adsarchitects2020/" target="_blank">
                <svg width="14" height="14" viewBox="0 0 64 64">
                  <path d="M32 16.9c-8.3 0-15 6.8-15 15.1s6.7 15.1 15 15.1S47 40.3 47 32s-6.7-15.1-15-15.1zm0 25.2c-5.5 0-10-4.5-10-10.1s4.5-10.1 10-10.1S42 26.4 42 32s-4.5 10.1-10 10.1zM47 10c-2.8 0-5 2.3-5 5s2.2 5 5 5 5-2.3 5-5-2.2-5-5-5z" />
                  <path d="M48 0H16C7.2 0 0 7.2 0 16v31.7C0 56.7 7.3 64 16.3 64h31.5C56.7 64 64 56.7 64 47.7V16c0-8.8-7.2-16-16-16zm11 47.7C59 53.9 54 59 47.8 59H16.3C10.1 59 5 54 5 47.8V16C5 9.9 9.9 5 16 5h32c6.1 0 11 4.9 11 11v31.7z" />
                </svg>
              </a>
            </li>
          </ul>

          <div className="footer-3__copyrights">
            <a href="https://wa.me/919033718216?text=I'd%20like%20to%20connect" target="_blank" className="floatleft wpbtn">

              <img alt="Architect,Urban Designer,Interior designer" loading="lazy" className="my-float wpbtn2" src={imgwhatsapp} />


            </a>
            <p>
              ©

              <script>
                document.write(new Date().getFullYear())
              </script>
              ADS

            </p>
            <p>All Rights Reserved</p>
          </div>
        </footer>
      </div>



    </>
  );
};

export default authLayout(Index);
